import { 
  createRouteRef, 
  createSubRouteRef 
} from '@backstage/core-plugin-api';
import { EpDevPPluginIds } from '@solace-labs/backstage-plugin-ep-devp-common';
import { EpDevPConsumerProductsApiRoutesFactory } from '../../ep-devp-consumer-products-common';

const PluginId = EpDevPPluginIds.EpDevPEventApiProductsPluginId;

export const rootRouteRef = createRouteRef({
  id: `${PluginId}:route:root`,
});

export const consumerProductsListRouteRef = createSubRouteRef({
  id: `${PluginId}:route:list`,
  parent: rootRouteRef,
  path: '/:organizationId',
});
EpDevPConsumerProductsApiRoutesFactory.validateRoute({
  pluginId: PluginId,
  actualRoute: consumerProductsListRouteRef.path,
  expectedRoute: EpDevPConsumerProductsApiRoutesFactory.getSubRouteList()
});

export const consumerProductsViewRouteRef = createSubRouteRef({
  id: `${PluginId}:route:view`,
  parent: rootRouteRef,
  path: '/:organizationId/:domainId/:eventApiProductId/*'
});
EpDevPConsumerProductsApiRoutesFactory.validateRoute({
  pluginId: PluginId,
  actualRoute: consumerProductsViewRouteRef.path,
  expectedRoute: `${EpDevPConsumerProductsApiRoutesFactory.getSubRouteConsumerProductById()}/*`
});
